import { useAuth } from 'contexts/AuthContext'
import { useState } from 'react'
import { toast } from 'react-toastify'
import { useLocation } from 'wouter'

// Hook personalizado `useFetch` para realizar peticiones API y manejar su estado
export default function useFetch() {
  const { token } = useAuth()
  const [location, setLocation] = useLocation()

  // useState()
  const [loading, setLoading] = useState(false)
  const [isCalled, setIsCalled] = useState(false)
  const [data, setData] = useState(null)
  const [error, setError] = useState(null)
  const [message, setMessage] = useState(null)

  async function fetchAction(params) {
    // Reinicia los estados antes de realizar la nueva solicitud
    setIsCalled(true)
    setData(null)
    setError(null)
    setMessage(null)
    setLoading(true)

    // Autorización API:
    const authorization = token ? `Basic ${btoa(token)}` : null

    try {
      // Cabeceras:
      const headers = params.formData
        ? { Accept: 'multipart/form-data', Authorization: authorization }
        : {
            'Content-Type': 'application/json',
            Authorization: authorization
          }

      // Cuerpo:
      const body = params.formData
        ? params.formData
        : JSON.stringify(params.body)

      // Realiza la solicitud `fetch` a la API
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/${params.url}`,
        {
          method: params.method,
          headers,
          body,
          credentials: 'include'
        }
      )

      if (response.ok) {
        const responseData = await response.json()
        setData(responseData)
        setMessage(responseData.message)
      }

      if (!response.ok) {
        if (
          (response.status === 401 &&
            window.location.pathname !== '/login' &&
            window.location.pathname !== '/logout') ||
          response.status === 403
        ) {
          setLocation('/logout')

          // Función para mostrar un mensaje de error
          toast.error('Sessión caducada', {
            position: 'top-center',
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: 'light'
          })
        } else {
          const errorData = await response.json()
          setError(errorData.error)
          console.log('useFetch() - error: ', errorData)
        }
      }
    } catch (error) {
      console.log('useFetch() - catch: ', error)
      setError(error) // Si ocurre un error durante la solicitud, se almacena el error
    } finally {
      setLoading(false) // Independientemente del resultado, se indica que la solicitud ha terminado
    }
  }

  // Retorna un array con el estado actual de la solicitud y la función `fetchAction`
  return [
    {
      loading, // Estado de carga
      isCalled, // Indica si la función fue llamada
      data, // Datos de la respuesta
      error, // Errores de la respuesta
      message // Mensajes de la respuesta
    },
    fetchAction // Función para realizar la solicitud
  ]
}
